import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after }) => {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const move = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    setPos((x / rect.width) * 100);
  }, []);

  const onDown = (e) => { dragging.current = true; move(e.clientX ?? e.touches?.[0]?.clientX); };
  const onMove = (e) => { if (dragging.current) move(e.clientX ?? e.touches?.[0]?.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[4/5] overflow-hidden rounded-lg gold-border select-none cursor-ew-resize bg-obsidian-2"
      data-testid="before-after-slider"
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      {/* After (result) - base layer */}
      <img src={after} alt="Draped result" className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} />
      <span className="absolute top-3 right-3 caption bg-obsidian/70 px-2.5 py-1 rounded pointer-events-none">After</span>

      {/* Before (uploaded) - clipped layer */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt="Your photo"
          className="absolute inset-0 h-full object-cover"
          style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%", maxWidth: "none" }}
          draggable={false}
        />
        <span className="absolute top-3 left-3 caption bg-obsidian/70 px-2.5 py-1 rounded">Before</span>
      </div>

      {/* Handle */}
      <div className="absolute top-0 bottom-0 pointer-events-none" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="w-0.5 h-full bg-gold/80" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-gold text-obsidian grid place-items-center gold-glow">
          <MoveHorizontal className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};
